var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm.isLoadingFirstTime
        ? _c(
            "div",
            { staticClass: "trbo-a-wizard-page-products__loading" },
            [_c("loading-indicator")],
            1
          )
        : _c(
            "div",
            { class: _vm.listClasses },
            _vm._l(_vm.products, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "trbo-a-wizard-page-products__list__item",
                },
                [
                  _c("products-item", {
                    ref: "productsItem",
                    refInFor: true,
                    staticClass: "trbo-a-products-item",
                    attrs: {
                      item: item,
                      message: _vm.message,
                      "keep-attribute-matching-expanded":
                        _vm.keepAttributeMatchingExpanded,
                      "routine-header-height": "300px",
                      "is-add-to-cart-disabled": _vm.isAddToCartDisabled,
                    },
                    on: {
                      "product-clicked": _vm.handleProductClickedEvent,
                      "product-added-to-cart":
                        _vm.handleProductAddedToCartEvent,
                      "attribute-matching-list-expanded":
                        _vm.handleAttributeMatchingListExpandedEvent,
                      "product-info-clicked": _vm.handleProductInfoClickedEvent,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm.noProducts
        ? _c("no-products", {
            on: {
              restart: function ($event) {
                return _vm.$emit("restart")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddRoutineToCartButton
        ? _c("div", { class: _vm.wizardPageProductsActions }, [
            _c(
              "button",
              {
                staticClass: "trbo-a-wizard-page-products__actions__button",
                on: { click: _vm.addRoutineToCart },
              },
              [
                _c("add-to-cart-icon"),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trbo-a-wizard-page-products__actions__button__text",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("product.addRoutineToCart")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isShowingCheckOrSpinnerIcons
              ? _c(
                  "div",
                  {
                    staticClass:
                      "trbo-a-wizard-page-products__actions__feedback",
                  },
                  [
                    _vm.isShowingCheckIcon ? _c("add-to-cart-check") : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowingSpinnerIcon
                      ? _c("spinner", { attrs: { size: "small" } })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }